import React from 'react'
import logo from '../logo.svg'
import { Link } from "react-router-dom"
import './Landing.sass'

const Landing = () => {

        return (
                <div className="bg landing">
                        <p className="landing__title">Simonline</p>
                        <img src={logo} className="landing__img" alt="logo" />
                        <div>
                                <Link to={'login'} className="landing__login">Login</Link>
                        </div>
                        <div>
                                <Link to={'register'} className="landing__register">Register</Link>
                        </div>
                </div>
        )
}
export default Landing